export default "__VITE_ASSET__BlG_$C0A__"